import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-up",
  "use": "icon-chevron-up-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-chevron-up\"><path d=\"m9.4 21.8 6.6-6.6 6.6 6.6 1.4-1.6-8-8-8 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol